export default __webpack_public_path__ + "static/media/masthead.5073ebfe.webp";